import styled from "styled-components";

export const ChartFill = styled.div`
  flex: 1;
  min-height: 0;
`;

export const IncomeSpan = styled.span`
  color: var(--color-success);
`;

export const ExpensesSpan = styled.span`
  color: var(--color-error);
`;

export const NetSpan = styled.span<{ $positive: boolean }>`
  color: ${({ $positive }) =>
    $positive ? "var(--color-success)" : "var(--color-error)"};
`;
